export default __webpack_public_path__ + "static/media/hht2_ani_12.4c0efc9e.png";